import React from "react";

export default function PointDefault({id, x, y, selected, index, onClick}) {
    const normalColor= "#000000";
    const selectedColor= "#ffc000";

    return(
        <div style={{width:"60px", display:"flex", position:"absolute", left:x, top:y,
            alignContent:"center", justifyContent:"center", userSelect:"none",
            cursor:"pointer"}} 
            onClick={()=>onClick(index)}>
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg" 
            width="45pt" height="45pt" 
            viewBox="0 0 800 1280" preserveAspectRatio="xMidYMid meet">
            <g transform="translate(0.000000,1280) scale(0.100000,-0.100000)" fill={selected ? selectedColor: normalColor} stroke="none">
                <path d="M3700 12789 c-604 -45 -1196 -221 -1695 -504 -913 -518 -1599 -1391 -1864 -2375 -58 -212 -95 -412 -122 -660 -17 -150 -17 -632 -1 -775 62 -536 213 -994 498 -1510 444 -806 507 -910 1103 -1823 397 -609 616 -961 825 -1326 703 -1225 1156 -2385 1422 -3634 l39 -182 110 0 111 0 48 228 c281 1350 770 2539 1625 3954 169 281 331 536 656 1033 457 699 644 1000 810 1304 133 245 442 879 502 1031 372 943 312 2106 -157 3040 -395 789 -1032 1421 -1806 1795 -642 310 -1405 457 -2104 404z"/>
            </g>
            </svg>
            <p style={{margin:"5px", position:"absolute", 
                color:selected ===  false ? "var(--font-color-white)":"var(--font-color-black)",
                fontFamily:"AgencyB", fontSize:"1.5rem"}}>
                {id}
            </p>
        </div>
    );
}